/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.commentModule')
  .directive('bulbCommentLower', ['BulbAuthService', 'BulbCommentService', '$timeout', bulbCommentLower]);

function bulbCommentLower(BulbAuthService, BulbCommentService, $timeout) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/comment/comment-lower.html',
    controller: 'CommentController as commentCtrl',
    link: function link(scope, element, attrs, commentCtrl) {
      scope.currentUser = BulbAuthService.currentUser;
      scope.commentService = BulbCommentService;
      scope.allowed = BulbAuthService.currentUser.allowed;

      scope.jump = function (thread) {
        const target = document.querySelector(`[bulb-id='${thread.targetId}']`)
          || document.querySelector(`[bulb-block-id='${thread.targetId}']`)
          || document.querySelector(`[id='${thread.targetId}']`);
        jQuery('html,body').animate({
          scrollTop: target.offsetTop + 140, // This value is the value of the pageview header + a 20 px margin
        });
        // This method call updates the active comment thread id to open the comment
        BulbCommentService.updateCommentThreads(thread.targetId);

      };

      const closeMenu = function () {
        commentCtrl.menuVisible = false;
        // Wait for current digest cycle to complete before calling apply.
        $timeout(() => {
          scope.$apply();
        }, 1);
      };

      $('#bulb-main').on('click touch', closeMenu);
      scope.$on('$destroy', () => {
        $('#bulb-main').off('click touch', closeMenu);
      });

      scope.$watch(
        () => BulbCommentService.lowerScrollTargetId,
        (val) => {
          if (!val) {
            return;
          }
          const id = `#comment-lower-thread-${BulbCommentService.lowerScrollTargetId}`;
          $('html,body').animate({
            scrollTop: jQuery(id).offset().top,
          }, 500);
          BulbCommentService.lowerScrollTargetId = null;
        });
    },
  };
}
